import React, { useEffect, useState } from "react";
import Quizquestion from "./Quizquestion";
import { useAccessCard } from "../../../ContextProvider/Accesscardprovider";
import { useLocation, useNavigate } from "react-router-dom";
import { cleanedString } from "../../../Helper/Calculation";
import { getCurrentUserDetail, getUserDocId } from "../../../Localstorage";
import { upsertResultData } from "../../../Firebase/Course-fb";

const Quiz = () => {
  const [showReviewPanel, setShowReviewPanel] = useState(false);
  const { timeLeft, setTimeLeft, setAnswer, setMarks, marks } = useAccessCard();
  const location = useLocation();
  const navigate = useNavigate();

  const [quizData, setQuizData] = useState(null);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [hasStarted, setHasStarted] = useState(false);
  const [index, setIndex] = useState(0);
  const [quiz, setQuiz] = useState(null);


  useEffect(() => {
    let data = location.state;

    if (!data) {
      const saved = sessionStorage.getItem("activeQuiz");
      if (saved) {
        data = JSON.parse(saved);
      } else {
        navigate("/", { replace: true });
        return;
      }
    } else {
      sessionStorage.setItem("activeQuiz", JSON.stringify(data));
    }

    const { quiz_code, time, quizName, questions } = data;
    if (time > 0 && questions?.length) {
      setQuizData({ quiz_code, time, quizName, questions });
      setTimeLeft(time * 60);
      setSelectedOptions(new Array(questions.length).fill(null));
      setQuiz(questions[0]);
      setHasStarted(true);
    }
  }, [location.state, navigate, setTimeLeft]);

  useEffect(() => {
    if (!hasStarted || !quizData) return;
    const timer = setInterval(() => {
      setTimeLeft((prevTime) => {
        if (prevTime <= 1) {
          clearInterval(timer);
          onTimeUp();
          return 0;
        }
        // else if(prevTime == 0){
        //   navigate("/")
        // }
        return prevTime - 1;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, [hasStarted, quizData, setTimeLeft]);

  useEffect(() => {
    if (timeLeft > 0) {
      sessionStorage.setItem("qquizTimeLeft", timeLeft);
      sessionStorage.setItem("qquizAnswer", JSON.stringify(selectedOptions));
    }
  }, [timeLeft]);

  const setWithExpiry = (key, value) => {
    const item = {
      value: value,
    };
    localStorage.setItem(key, JSON.stringify(item));
  };

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${minutes} Minute${minutes !== 1 ? "s" : ""} ${secs} Second${secs !== 1 ? "s" : ""}`;
  };

  const onTimeUp = async () => {
    const { quiz_code, time, quizName, questions } = quizData;

    const marks = selectedOptions.filter((val, idx) =>
      val !== null && cleanedString(val) === cleanedString(questions[idx].answer)
    ).length;

    setMarks(marks);
    setAnswer(selectedOptions);
    sessionStorage.removeItem("activeQuiz");

    const ansOptions = JSON.parse(sessionStorage.getItem("qquizAnswer"));
    const marksOptions = JSON.parse(sessionStorage.getItem("qquizMarks"));
    const timeLeftOptions = JSON.parse(sessionStorage.getItem("qquizTimeLeft"));


    const quizDataToStore = {
      quizTime: time,
      quizAnswer: JSON.stringify(ansOptions),
      quizMarks: marksOptions,
      quizTimeLeft: timeLeftOptions,
      quizHead: quizName,
      quizQuestions: questions,
    };

    // setWithExpiry(String(quiz_code), quizDataToStore, 60 * 1000);
    setWithExpiry("Quiz", quizDataToStore);
    const studentResult = {
      student_name: getCurrentUserDetail()[0].name,
      student_id: getUserDocId(),
      quiz_code: sessionStorage.getItem("quizCode"),
      quiz_name: quizName,
      correct_answered: marksOptions,
      wrong_answered: (ansOptions.length - ansOptions.filter(item => item === null).length) - marks,
      un_answered: ansOptions.filter(item => item === null).length,
      attempt_count: 18,
      time_taken: (time * 60) - timeLeftOptions, // in seconds
      actual_time: time * 60, // in seconds
      time_stamp: Date.now(), // Unix timestamp (ms)
      question_list: questions,
      answer_list: ansOptions
    };

    await upsertResultData(getUserDocId(),sessionStorage.getItem("quizCode"),studentResult)

    // sessionStorage.removeItem("qquizTimeLeft");
    // sessionStorage.removeItem("qquizAnswer");
    // sessionStorage.removeItem("qquizMarks");

    navigate("/quiz-score");
  };

  const handleQuestionPannel = (qnumber) => {
    setQuiz(quizData.questions[qnumber]);
    setIndex(qnumber);
  };

  if (!quizData || !quiz) return null;

  const { time, quizName, questions } = quizData;

  return (
    <div>
      <div className="quiz-container">
        <div className="headers">
          <h2 className="headers_topic">Topic: {quizName}</h2>
          <div className="timer">
            <span>Remaining Time: {formatTime(timeLeft)}</span>
            <div>Total Duration: {time} Minutes</div>
          </div>
        </div>

        <Quizquestion
          questions={questions}
          selectedOptions={selectedOptions}
          setSelectedOptions={setSelectedOptions}
          showReviewPanel={showReviewPanel}
          setShowReviewPanel={setShowReviewPanel}
          quiz={quiz}
          setQuiz={setQuiz}
          index={index}
          setIndex={setIndex}
        />
      </div>

      {showReviewPanel && (
        <div className="review-backdrop">
          <div className="review-panel-overlay">
            <div className="review-panel">
              <div>
                <span className="close-card" onClick={() => setShowReviewPanel(false)}>X</span>
                <h3>Question display board</h3>
                <hr />
              </div>
              <div className="status-bar">
                <span className="answered">✔ Answered: {selectedOptions.filter(Boolean).length}</span>
                <span className="unanswered">✖ Unanswered: {questions.length - selectedOptions.filter(Boolean).length}</span>
              </div>
              <div className="question-grid">
                {[...Array(questions.length)].map((_, i) => (
                  <div
                    key={i}
                    className={`question-number ${selectedOptions[i] ? "answered" : "unanswered"}`}
                    onClick={() => handleQuestionPannel(i)}
                  >
                    {i + 1}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Quiz;
